// extracted by mini-css-extract-plugin
export default {"mainPageContainer":"main-page_mainPageContainer__z6BLX","hiddenMainPage":"main-page_hiddenMainPage__7EwHL","loader":"main-page_loader__JrB5Y"};